<template>
  <div>
    <SchemaTablePage
      ref="tablePageRef"
      layout-mode="tab"
      :search-schema="searchSchema"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
    >
      <template #table-header>
        <div>
          <el-button type="primary" size="mini" @click="handleAdd">新增</el-button>
        </div>
      </template>

      <template #colImageUrl="{ row }">
        <el-image
          v-if="row.image_url"
          :src="row.image_url"
          fit="cover"
          style="width: 60px; height: 60px; cursor: pointer"
          :preview-src-list="[row.image_url]"
        />
        <span v-else>无</span>
      </template>
      <template #colJumpUrl="{ row }">
        <el-link v-if="row.jump_url" type="primary" :href="row.jump_url" target="_blank">{{ row.jump_url }}</el-link>
        <span v-else>无</span>
      </template>
      <template #colDisplayTime="{ row }">
        <span v-if="row.end_at === -1">永久有效</span>
        <span v-else
          >{{ row.start_at ? parseTime(row.start_at) : '' }} 至 {{ row.end_at ? parseTime(row.end_at) : '' }}</span
        >
      </template>
      <template #colStatus="{ row }">
        <el-tag v-if="row.status === 'enabled'" size="small" type="success">启用</el-tag>
        <el-tag v-else-if="row.status === 'disabled'" size="small">禁用</el-tag>
        <span v-else>{{ row.status }}</span>
      </template>
      <template #colUpdatedAt="{ row }">
        <span v-if="row.updated_at">{{ parseTime(row.updated_at) }}</span>
        <span v-else>无</span>
      </template>
      <template #colActions="{ row }">
        <el-button size="small" type="text" @click="handleEdit(row)">编辑</el-button>
        <el-button
          size="small"
          type="text"
          :class="row.status === 'disabled' ? 'success-button' : 'danger-button'"
          @click="handleToggleStatus(row)"
        >
          {{ row.status === 'disabled' ? '启用' : '禁用' }}
        </el-button>
        <el-button size="small" type="text" class="danger-button" @click="handleDelete(row)">删除</el-button>
      </template>
    </SchemaTablePage>

    <ManageFloatingIconDialog
      :visible.sync="dialogVisible"
      :dialog-title="dialogTitle"
      :form-data="formData"
      :dialog-loading="dialogLoading"
      @success="handleDialogSuccess"
    />
  </div>
</template>

<script>
import {
  deleteFloatingIcon,
  getFloatingIconDetail,
  getFloatingIconList,
  updateFloatingIcon,
} from '@/api/operation/floatingIcon.js'
import { parseTime } from '@/utils'
import ManageFloatingIconDialog from './ManageFloatingIconDialog.vue'
import SchemaTablePage from '@/components/SchemaTablePage'

export default {
  name: 'FloatingIconTab',
  components: { ManageFloatingIconDialog, SchemaTablePage },
  data() {
    return {
      parseTime,
      defaultQuery: {
        startTimeRange: [],
        status: '',
      },
      searchSchema: [
        {
          prop: 'startTimeRange',
          label: '展示时间',
          component: 'datetime-range',
          componentProps: { defaultTime: ['00:00:00', '23:59:59'], clearable: true },
          span: { xs: 24, sm: 12, md: 10 },
        },
        {
          prop: 'status',
          label: '状态',
          component: 'select',
          componentProps: { clearable: true },
          options: [
            { label: '全部', value: '' },
            { label: '启用', value: 'enabled' },
            { label: '禁用', value: 'disabled' },
          ],
        },
        { component: 'actions' },
      ],
      tableColumns: [
        { prop: 'image_url', label: '悬浮图标', width: 100, align: 'center', resizable: false, slot: 'colImageUrl' },
        { prop: 'jump_url', label: '详情链接', minWidth: 240, resizable: false, slot: 'colJumpUrl' },
        { prop: 'sort', label: '排序', width: 60, resizable: false },
        { prop: 'end_at', label: '展示时间', minWidth: 280, resizable: false, slot: 'colDisplayTime' },
        { prop: 'status', label: '状态', width: 80, align: 'center', resizable: false, slot: 'colStatus' },
        { prop: 'updated_at', label: '最后操作时间', minWidth: 160, resizable: false, slot: 'colUpdatedAt' },
        {
          fixed: 'right',
          prop: 'action',
          label: '操作',
          width: 120,
          align: 'center',
          resizable: false,
          slot: 'colActions',
        },
      ],
      dialogVisible: false,
      dialogTitle: '新增首页悬浮图标',
      formData: {},
      dialogLoading: false,
    }
  },
  methods: {
    request(params) {
      return getFloatingIconList(params)
    },
    buildParams({ query, page, limit }) {
      const params = {
        page,
        page_size: limit,
      }
      if (query.startTimeRange && query.startTimeRange.length === 2) {
        params.start_at = Math.floor(new Date(query.startTimeRange[0]).getTime())
        params.end_at = Math.floor(new Date(query.startTimeRange[1]).getTime())
      }
      if (query.status) {
        params.status = query.status
      }
      return params
    },
    parseResult(res) {
      if (!res || res.code !== 0) {
        if (res && res.code !== 0) {
          this.$message.error('获取数据失败：' + (res.msg || '未知错误'))
        }
        return { list: [], total: 0 }
      }
      return {
        list: res.data.items || [],
        total: res.data.total != null ? res.data.total : 0,
      }
    },
    reloadTable() {
      this.$refs.tablePageRef?.reload?.()
    },
    handleRefresh() {
      this.reloadTable()
    },
    handleAdd() {
      this.dialogTitle = '新增首页悬浮图标'
      this.formData = {}
      this.dialogVisible = true
    },
    async handleEdit(row) {
      this.dialogTitle = '编辑首页悬浮图标'
      this.dialogLoading = true
      try {
        const response = await getFloatingIconDetail({ id: row.id })
        if (response.code === 0) {
          this.formData = response.data
          this.dialogVisible = true
        } else {
          this.$message.error('获取详情失败：' + (response.msg || '未知错误'))
        }
      } catch (error) {
        this.$message.error('获取详情失败：' + error.message)
      } finally {
        this.dialogLoading = false
      }
    },
    async handleToggleStatus(row) {
      try {
        const response = await updateFloatingIcon({
          id: row.id,
          status: row.status === 'disabled' ? 'enabled' : 'disabled',
        })
        if (response.code === 0) {
          this.$message.success('状态切换成功')
          this.reloadTable()
        } else {
          this.$message.error('状态切换失败：' + (response.msg || '未知错误'))
        }
      } catch (error) {
        this.$message.error('状态切换失败：' + error.message)
      }
    },
    handleDelete(row) {
      this.$confirm('确定要删除这条首页悬浮图标吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          try {
            const response = await deleteFloatingIcon({ id: row.id })
            if (response.code === 0) {
              this.$message.success('删除成功')
              this.reloadTable()
            } else {
              this.$message.error('删除失败：' + (response.msg || '未知错误'))
            }
          } catch (error) {
            this.$message.error('删除失败：' + error.message)
          }
        })
        .catch(() => {})
    },
    handleDialogSuccess() {
      this.reloadTable()
      this.dialogVisible = false
    },
  },
}
</script>

<style scoped></style>
